import { render, staticRenderFns } from "./TeacherCourseProjectDetail.vue?vue&type=template&id=3c170fcb&scoped=true&"
import script from "./TeacherCourseProjectDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCourseProjectDetail.vue?vue&type=style&index=0&id=3c170fcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c170fcb",
  null
  
)

export default component.exports